import TextInput from "../Comon/TextInput/TextInput";
import React, {useState} from "react";
import Headline from "../Comon/Headline/Headline";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import PersonalizationBoolean from "./SurveySettingsPersonalization/screens/components/PersonalizationBoolean";
import Dropdown from "../Admin Panel/Dropdown/Dropdown";
import RadioThemed from "../Comon/RadioThemed";

export default function SurveyAdditionalWellnessSettings({
    pdfColor,
    setPdfColor = () => {},
    surveyOrderTransition,
    setSurveyOrderTransition = () => {},
    setHasMadeAnyChanges = () => {},
})
{
    const app = useSelector((state) => state.app);

    const wellnessSurveyOrderTransitionOptions = app?.app_data?.wellnessSurveyOrderTransitionOptions?.map(item => {
        return {
            ...item,
            name:item?.label,
        }
    });
    const wellnessPdfColorOptions = app?.app_data?.wellnessPdfColorOptions;

    const [showWellnessPdfColorPreview, setShowWellnessPdfColorPreview] = useState(false);

    return <div>
        <div style={{marginBottom:'10px'}}>
            <Headline
                text={'PDF Color'}
                type={"Headline-personalization"}
            />
            <p>
                Choose the predefined color scheme for the wellness PDF design, and click on each to see an example.
            </p>
        </div>

        <div
            style={{
                display:'flex',
                flexDirection:'column',
                gap:'10px',
            }}
        >
            {
                wellnessPdfColorOptions?.map((item,index) => {
                    return <div
                        key={index}
                        style={{
                            display:'flex',
                            gap:'5px',
                            alignItems:'center',
                            justifyContent:'flex-start',
                            cursor:'pointer',
                        }}

                    >
                        <div
                            style={{
                                display:'flex',
                                gap:'5px',
                                alignItems:'center',
                                justifyContent:'flex-start',
                                cursor:'pointer',
                            }}
                            onClick={() => {
                                setPdfColor(item?.value)
                                setHasMadeAnyChanges(true)
                            }}
                        >
                            <RadioThemed
                                isChecked={pdfColor === item?.value}
                            />
                            <div style={{
                                color:'rgba(73, 73, 73, 1)',
                            }}>{item?.label}</div>
                        </div>

                        <div
                            style={{
                                textDecoration:'underline',
                                color:'#4f7c9c',
                                cursor:'pointer',
                            }}
                            onClick={() => setShowWellnessPdfColorPreview(item)}
                        >
                            (preview)
                        </div>
                    </div>
                })
            }
        </div>


        {showWellnessPdfColorPreview &&   <div className="revertPopup">
            <div className="steperBackdrop">
                <div className="popupStyle" style={{textAlign:'center'}}>
                    <h2 style={{ marginBottom: "40px" }}>
                        {showWellnessPdfColorPreview?.label}
                    </h2>

                    <img
                        src={showWellnessPdfColorPreview?.url}
                        alt={showWellnessPdfColorPreview?.label}
                        style={{
                            textAlign:'center',
                            maxHeight:'60vh',
                            width:'auto',
                            objectFit:'contain',
                            marginBottom: "40px",
                        }}
                    />

                    <div className="revertButtons">
                        <button
                            className="apply"
                            onClick={() => {
                                setPdfColor(showWellnessPdfColorPreview?.value)
                                setHasMadeAnyChanges(true)
                                setShowWellnessPdfColorPreview(false)
                            }}
                        >
                            Choose this color scheme
                        </button>

                        <button
                            className="cancel"
                            onClick={() => setShowWellnessPdfColorPreview(false)}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>}


        <div style={{marginBottom:'20px', marginTop:'30px'}}>
            <Headline
                text={'Survey Transition Settings'}
                type={"Headline-personalization"}
            />
            <p>
                By default, all patients will be switched from Standard Surveys to the Wellness Survey after the 6th survey (CP, CF, CF+). You can choose a different option below.
            </p>
        </div>


        <Dropdown
            type={"surveyOrderTransition"}
            setSelectedOption={(option) => {
                setSurveyOrderTransition(option?.value)
                setHasMadeAnyChanges(true)
            }}
            selectedOption={surveyOrderTransition}
            options={wellnessSurveyOrderTransitionOptions}
            app={app}
            placeholder={"Wellness survey transition"}
        />


    </div>
}
